import React from 'react';
import Button, { ButtonModeE } from '../../components/Button/Button';
import usePopup from '../../utils/hooks/usePopup';

import styles from './createNewProductionCompanyShort.module.scss';

const CreateNewProductionCompanyShortFooter = () => {
    const { removePopup } = usePopup();

    return (
        <div className={styles.buttonsWrapper}>
            <Button mode={ButtonModeE.OUTLINED} onClick={removePopup}>Cancel</Button>
            <Button form='create-short-prod-company' useGlobalLoading>Save production company</Button>
        </div>
    );
};

export default CreateNewProductionCompanyShortFooter;